// extracted by mini-css-extract-plugin
export default {"fieldsWrapper":"VehicleInformation_fieldsWrapper__lv+Ha","wrapper":"VehicleInformation_wrapper__gKSyl"};